import type { WorkbenchActionExecutionEntry } from '@shared/business-workbench/workbench-action-execution-log';

export type AuxiliaryTabKey = 'timeline' | 'audit' | 'evidence' | 'validation' | 'explain';

export const WORKBENCH_AUXILIARY_REFRESH_EVENT = 'inflomatrix:workbench-auxiliary-refresh';
export const WORKBENCH_ACTION_EXECUTED_EVENT = 'inflomatrix:workbench-action-executed';
export const WORKBENCH_AUXILIARY_OPEN_TAB_EVENT = 'inflomatrix:workbench-auxiliary-open-tab';

export interface WorkbenchActionExecutedDetail {
  entry: WorkbenchActionExecutionEntry;
}

export interface WorkbenchAuxiliaryOpenTabDetail {
  tab: AuxiliaryTabKey;
  expand?: boolean;
}

export function emitWorkbenchAuxiliaryRefresh(): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new CustomEvent(WORKBENCH_AUXILIARY_REFRESH_EVENT));
}

export function emitWorkbenchActionExecuted(entry: WorkbenchActionExecutionEntry): void {
  if (typeof window === 'undefined') {
    return;
  }
  const detail: WorkbenchActionExecutedDetail = { entry };
  window.dispatchEvent(
    new CustomEvent<WorkbenchActionExecutedDetail>(WORKBENCH_ACTION_EXECUTED_EVENT, { detail })
  );
  emitWorkbenchAuxiliaryRefresh();
}

export function emitWorkbenchAuxiliaryOpenTab(
  tab: AuxiliaryTabKey,
  options?: { expand?: boolean }
): void {
  if (typeof window === 'undefined') {
    return;
  }
  const detail: WorkbenchAuxiliaryOpenTabDetail = {
    tab,
    ...(options?.expand !== undefined ? { expand: options.expand } : {}),
  };
  window.dispatchEvent(
    new CustomEvent<WorkbenchAuxiliaryOpenTabDetail>(WORKBENCH_AUXILIARY_OPEN_TAB_EVENT, {
      detail,
    })
  );
}
